/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactNode, createContext, useMemo, useState } from "react";

// Created this context because of the Alerts shown at the top of ProviderTrackingPage
export const ShipmentTrackingContext = createContext({
  isReferencesDialogOpen: false,
  setIsReferencesDialogOpen: (_: boolean) => {},
  showSubmitPodDialog: false,
  setShowSubmitPodDialog: (_: boolean) => {},
  isEditScheduleDialogOpen: false,
  setIsEditScheduleDialogOpen: (_: boolean) => {},
});

// Will be used in Tracking page
export function ShipmentTrackingContextProvider({ children }: { children: ReactNode }) {
  const [isReferencesDialogOpen, setIsReferencesDialogOpen] = useState(false);
  const [showSubmitPodDialog, setShowSubmitPodDialog] = useState(false);
  const [isEditScheduleDialogOpen, setIsEditScheduleDialogOpen] = useState(false);

  const contextValue = useMemo(
    () => ({
      isReferencesDialogOpen,
      setIsReferencesDialogOpen,
      showSubmitPodDialog,
      setShowSubmitPodDialog,
      isEditScheduleDialogOpen,
      setIsEditScheduleDialogOpen,
    }),
    [
      isReferencesDialogOpen,
      setIsReferencesDialogOpen,
      showSubmitPodDialog,
      setShowSubmitPodDialog,
      isEditScheduleDialogOpen,
      setIsEditScheduleDialogOpen,
    ],
  );

  return <ShipmentTrackingContext.Provider value={contextValue}>{children}</ShipmentTrackingContext.Provider>;
}
